import { Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { MultiTabComponent } from './multi-tab/multi-tab.component';

export const routes: Routes = [
  {
    path: ':lang/landing',
    loadComponent: () => import('./landing/landing.component').then((m) => m.LandingComponent),
  },
  {
    path: ':lang/login',
    loadComponent: () => import('./landing/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: ':lang/register',
    loadComponent: () => import('./landing/register/register.component').then((m) => m.RegisterComponent),
  },
  {
    path: ':lang/resetPassword',
    loadComponent: () =>
      import('./landing/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
  },
  {
    path: ':lang/forgotPassword',
    loadComponent: () =>
      import('./landing/login/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
  },
  {
    path: ':lang/emailValidated',
    loadComponent: () =>
      import('./landing/email-validated/email-validated.component').then((m) => m.EmailValidatedComponent),
  },
  {
    path: ':lang/validateEmail',
    loadComponent: () =>
      import('./landing/validate-email/validate-email.component').then((m) => m.ValidateEmailComponent),
  },
  {
    path: ':lang/game/:id',
    loadComponent: () => import('./game/game.component').then((m) => m.GameComponent),
  },
  {
    path: ':lang/logout',
    loadComponent: () => import('./landing/logout/logout.component').then((m) => m.LogoutComponent),
  },
  {
    path: ':lang',
    component: HomeComponent,
    children: [
      {
        path: 'games',
        loadComponent: () => import('./home/lobby/lobby.component').then((m) => m.LobbyComponent),
      },
      {
        path: 'profile',
        loadComponent: () => import('./home/profile/profile.component').then((m) => m.ProfileComponent),
      },
    ],
  },
  {
    path: ':lang/multiTab',
    component: MultiTabComponent,
  },
];
